// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sidebarMenuTippyStyles, sidebarMenuTippyWidth } from "@west/App/Components/Tippy/SidebarMenuTippy";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

sidebarMenuTippyStyles.container = {
    css: css`
        height: 100vh;
        border-radius: 0;
        width: ${sidebarMenuTippyWidth}px;
        &.tippy-box {
            &:after {
                content: "";
                position: absolute;
                background: ${color("common.white")};
                width: 100vw;
                height: 100vh;
                right: 0;
                left: 0;
                top: 0;
            }

            & > .tippy-content {
                padding: 0;
            }
        }
    `,
};
